(function () {
  if (window.__flyBundleAtcBridgeInitialized) {
    return;
  }

  window.__flyBundleAtcBridgeInitialized = true;

  var isProxyingClickToGfb = false;
  var enhancementTimer = null;
  var queuedEnhancementProducts = [];
  var isApplyingEnhancements = false;
  var observedBundleRoot = null;
  var bundleObserver = null;
  var bundleItemRatingsByHandle = null;
  var bundleSectionsConfig = null;
  var isSyncingBundleSectionSelections = false;
  var bundleSectionSyncTimer = null;
  var queuedBundleSectionPreferredCard = null;
  var isProgrammaticBundleSectionToggle = false;

  function syncTemplateTogetherClassAliases(rootNode) {
    var sourceRoot = rootNode;

    if (!sourceRoot || sourceRoot.nodeType !== 1) {
      sourceRoot = document.querySelector(
        '.main-product .product-info__bundle-app'
      );
    }

    if (!sourceRoot || typeof sourceRoot.querySelectorAll !== 'function') {
      return;
    }

    var candidates = [];

    if (
      sourceRoot.classList &&
      Array.prototype.some.call(sourceRoot.classList, function (className) {
        return className.indexOf('_Template1') > -1;
      })
    ) {
      candidates.push(sourceRoot);
    }

    Array.prototype.forEach.call(
      sourceRoot.querySelectorAll('[class*="_Template1"]'),
      function (node) {
        candidates.push(node);
      }
    );

    Array.prototype.forEach.call(candidates, function (node) {
      if (!node || !node.classList || !node.classList.length) {
        return;
      }

      var classNames = Array.prototype.slice.call(node.classList);
      classNames.forEach(function (className) {
        if (className.indexOf('_Template1') === -1) {
          return;
        }

        var togetherClassName = className.replace(/_Template1/g, '_Together');
        if (togetherClassName && !node.classList.contains(togetherClassName)) {
          node.classList.add(togetherClassName);
        }
      });
    });
  }

  function parseJsonScript(selector, fallback) {
    var script = document.querySelector(selector);

    if (!script) {
      return fallback;
    }

    try {
      return JSON.parse(script.textContent || '') || fallback;
    } catch (error) {
      return fallback;
    }
  }

  function normalizeProductHandle(rawValue) {
    return String(rawValue || '')
      .trim()
      .toLowerCase();
  }

  function normalizeText(rawValue) {
    return String(rawValue || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getBundleItemRatingsByHandle() {
    if (bundleItemRatingsByHandle !== null) {
      return bundleItemRatingsByHandle;
    }

    var rawRatings = parseJsonScript('[data-fly-bundle-item-ratings]', {});
    var normalizedRatings = {};

    if (rawRatings && typeof rawRatings === 'object') {
      Object.keys(rawRatings).forEach(function (rawHandle) {
        var normalizedHandle = normalizeProductHandle(rawHandle);
        var ratingMarkup = String(rawRatings[rawHandle] || '').trim();

        if (normalizedHandle && ratingMarkup) {
          normalizedRatings[normalizedHandle] = ratingMarkup;
        }
      });
    }

    bundleItemRatingsByHandle = normalizedRatings;
    return bundleItemRatingsByHandle;
  }

  function getProductHandleFromCard(productCard) {
    if (!productCard) {
      return '';
    }

    var handle = normalizeProductHandle(
      productCard.getAttribute('data-product-handle')
    );

    if (handle) {
      return handle;
    }

    var titleLink = productCard.querySelector(
      '.gfbFrequentBoughtWidgetProductTitle a[href*="/products/"], .gfbProductTitle_Template1 a[href*="/products/"], .gfbProductTitle_Together a[href*="/products/"]'
    );

    if (!titleLink) {
      return '';
    }

    var href = String(titleLink.getAttribute('href') || '');
    var match = href.match(/\/products\/([^/?#]+)/i);

    if (!match || !match[1]) {
      return '';
    }

    return normalizeProductHandle(match[1]);
  }

  function createRatingBadgeFromMarkup(ratingMarkup) {
    if (!ratingMarkup) {
      return null;
    }

    var template = document.createElement('template');
    template.innerHTML = String(ratingMarkup).trim();

    var ratingBadge = template.content.querySelector('.rating-badge');
    if (!ratingBadge) {
      return null;
    }

    return ratingBadge.cloneNode(true);
  }

  function getBundleItemRatingBadge(productCard) {
    var productHandle = getProductHandleFromCard(productCard);
    if (!productHandle) {
      return null;
    }

    var ratingsByHandle = getBundleItemRatingsByHandle();
    var ratingMarkup = ratingsByHandle[productHandle];

    return createRatingBadgeFromMarkup(ratingMarkup);
  }

  function getElementNode(node) {
    if (!node) {
      return null;
    }

    if (node.nodeType === 1) {
      return node;
    }

    if (node.nodeType === 3) {
      return node.parentElement || null;
    }

    return null;
  }

  function getGfbBundleAtcButton() {
    var bundleRoot = document.querySelector(
      '.main-product .product-info__bundle-app'
    );

    if (!bundleRoot) {
      return null;
    }

    syncTemplateTogetherClassAliases(bundleRoot);

    var gfbButton = bundleRoot.querySelector(
      '.gfbFrequentBoughtAddToCartButton, .gfbFooterAddToCartBtn_Together, .gfbFooterAddToCartBtn_Template1'
    );

    if (!gfbButton || !document.documentElement.contains(gfbButton)) {
      return null;
    }

    return gfbButton;
  }

  function getAllGfbProductCards() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '.main-product .product-info__bundle-app .gfbFrequentBoughtWidgetProductContainer, .main-product .product-info__bundle-app .gfbBundleProductContainer_Template1, .main-product .product-info__bundle-app .gfbBundleProductContainer_Together'
      )
    );
  }

  function normalizeBundleSectionProducts(rawProducts) {
    if (!Array.isArray(rawProducts)) {
      return [];
    }

    var productHandles = [];

    rawProducts.forEach(function (rawProduct) {
      var productHandle = '';

      if (typeof rawProduct === 'string') {
        productHandle = normalizeProductHandle(rawProduct);
      } else if (rawProduct && typeof rawProduct === 'object') {
        productHandle = normalizeProductHandle(
          rawProduct.handle ||
            rawProduct.productHandle ||
            rawProduct.product_handle ||
            ''
        );
      }

      if (!productHandle || productHandles.indexOf(productHandle) > -1) {
        return;
      }

      productHandles.push(productHandle);
    });

    return productHandles;
  }

  function getBundleSectionsConfig() {
    if (bundleSectionsConfig !== null) {
      return bundleSectionsConfig;
    }

    var rawConfig = parseJsonScript('[data-fly-bundle-sections]', {});
    var rawSections = [];

    if (Array.isArray(rawConfig)) {
      rawSections = rawConfig;
    } else if (rawConfig && Array.isArray(rawConfig.sections)) {
      rawSections = rawConfig.sections;
    }

    var sections = [];
    var sectionById = {};
    var handleToSectionId = {};

    rawSections.forEach(function (rawSection, sectionIndex) {
      if (!rawSection || typeof rawSection !== 'object') {
        return;
      }

      var sectionProducts = normalizeBundleSectionProducts(rawSection.products);
      if (!sectionProducts.length) {
        return;
      }

      var sectionId = String(
        rawSection.id || rawSection.handle || 'section-' + (sectionIndex + 1)
      ).trim();

      if (!sectionId) {
        sectionId = 'section-' + (sectionIndex + 1);
      }

      var separatorLabel = String(
        rawSection.separator ||
          rawSection.separatorLabel ||
          rawSection.separator_label ||
          'OR'
      ).trim();

      var sectionConfig = {
        id: sectionId,
        separator: separatorLabel || 'OR',
        products: sectionProducts
      };

      sections.push(sectionConfig);
      sectionById[sectionId] = sectionConfig;

      sectionProducts.forEach(function (productHandle) {
        if (!handleToSectionId[productHandle]) {
          handleToSectionId[productHandle] = sectionId;
        }
      });
    });

    bundleSectionsConfig = {
      sections: sections,
      sectionById: sectionById,
      handleToSectionId: handleToSectionId
    };

    return bundleSectionsConfig;
  }

  function getBundleSectionForProductCard(productCard) {
    var productHandle = getProductHandleFromCard(productCard);
    if (!productHandle) {
      return null;
    }

    var config = getBundleSectionsConfig();
    var sectionId = config.handleToSectionId[productHandle];
    if (!sectionId) {
      return null;
    }

    return config.sectionById[sectionId] || null;
  }

  function getBundleSectionCheckbox(productCard) {
    if (!productCard || typeof productCard.querySelector !== 'function') {
      return null;
    }

    var localCheckbox = productCard.querySelector('input[type="checkbox"]');
    if (localCheckbox) {
      return localCheckbox;
    }

    var bundleRoot = document.querySelector(
      '.main-product .product-info__bundle-app'
    );
    if (!bundleRoot || typeof bundleRoot.querySelectorAll !== 'function') {
      return null;
    }

    var productHandle = getProductHandleFromCard(productCard);
    var rootCheckboxes = Array.prototype.slice.call(
      bundleRoot.querySelectorAll('input[type="checkbox"]')
    );

    if (!rootCheckboxes.length) {
      return null;
    }

    if (productHandle) {
      var checkboxByHandle = rootCheckboxes.find(function (checkboxElement) {
        if (!checkboxElement || typeof checkboxElement.closest !== 'function') {
          return false;
        }

        var ownerCard = checkboxElement.closest(
          '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
        );

        return (
          ownerCard && getProductHandleFromCard(ownerCard) === productHandle
        );
      });

      if (checkboxByHandle) {
        return checkboxByHandle;
      }
    }

    var allCards = getAllGfbProductCards();
    var cardIndex = allCards.indexOf(productCard);

    if (cardIndex > -1 && rootCheckboxes[cardIndex]) {
      return rootCheckboxes[cardIndex];
    }

    return null;
  }

  function isBundleSectionCardSelected(productCard) {
    var checkbox = getBundleSectionCheckbox(productCard);

    if (checkbox) {
      return Boolean(checkbox.checked);
    }

    var ariaChecked = String(
      productCard && productCard.getAttribute
        ? productCard.getAttribute('aria-checked')
        : ''
    ).toLowerCase();

    if (ariaChecked === 'true') {
      return true;
    }

    if (ariaChecked === 'false') {
      return false;
    }

    return Boolean(
      productCard &&
        productCard.classList &&
        (productCard.classList.contains('is-selected') ||
          productCard.classList.contains('selected'))
    );
  }

  function setBundleSectionCardSelected(productCard, shouldSelect) {
    var checkbox = getBundleSectionCheckbox(productCard);

    if (!checkbox || checkbox.disabled) {
      return false;
    }

    if (Boolean(checkbox.checked) === shouldSelect) {
      return true;
    }

    isProgrammaticBundleSectionToggle = true;

    try {
      if (typeof checkbox.click === 'function') {
        checkbox.click();
      }
    } finally {
      window.setTimeout(function () {
        isProgrammaticBundleSectionToggle = false;
      }, 0);
    }

    if (Boolean(checkbox.checked) === shouldSelect) {
      return true;
    }

    checkbox.checked = shouldSelect;
    checkbox.dispatchEvent(new Event('input', { bubbles: true }));
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));

    return Boolean(checkbox.checked) === shouldSelect;
  }

  function annotateBundleSectionCards(cards) {
    var config = getBundleSectionsConfig();
    var productCards = Array.isArray(cards) ? cards : getAllGfbProductCards();
    productCards.forEach(function (productCard) {
      if (!productCard || !productCard.getAttribute) {
        return;
      }

      productCard.removeAttribute('data-c8-bundle-section-id');
      productCard.removeAttribute('data-c8-bundle-section-join');
    });

    if (!config.sections.length) {
      return;
    }

    productCards.forEach(function (productCard) {
      var sectionConfig = getBundleSectionForProductCard(productCard);
      if (!sectionConfig) {
        return;
      }

      productCard.setAttribute('data-c8-bundle-section-id', sectionConfig.id);
    });

    for (var cardIndex = 1; cardIndex < productCards.length; cardIndex += 1) {
      var currentCard = productCards[cardIndex];
      var previousCard = productCards[cardIndex - 1];

      if (!currentCard || !previousCard) {
        continue;
      }

      var currentSectionId = String(
        currentCard.getAttribute('data-c8-bundle-section-id') || ''
      ).trim();
      var previousSectionId = String(
        previousCard.getAttribute('data-c8-bundle-section-id') || ''
      ).trim();

      if (
        !currentSectionId ||
        currentSectionId !== previousSectionId ||
        !currentCard.parentNode ||
        currentCard.parentNode !== previousCard.parentNode
      ) {
        continue;
      }

      currentCard.setAttribute('data-c8-bundle-section-join', 'true');
    }
  }

  function updateBundleSectionSelectionState(cards) {
    var productCards = Array.isArray(cards) ? cards : getAllGfbProductCards();

    productCards.forEach(function (productCard) {
      if (!productCard || !productCard.getAttribute) {
        return;
      }

      var sectionId = String(
        productCard.getAttribute('data-c8-bundle-section-id') || ''
      ).trim();

      if (!sectionId) {
        productCard.removeAttribute('data-c8-bundle-section-selected');
        return;
      }

      productCard.setAttribute(
        'data-c8-bundle-section-selected',
        isBundleSectionCardSelected(productCard) ? 'true' : 'false'
      );
    });
  }

  function enforceSingleSelectionForSection(
    sectionId,
    preferredProductCard,
    cards
  ) {
    if (!sectionId) {
      return;
    }

    var productCards = Array.isArray(cards) ? cards : getAllGfbProductCards();
    var sectionCards = productCards.filter(function (productCard) {
      return (
        productCard &&
        productCard.getAttribute &&
        productCard.getAttribute('data-c8-bundle-section-id') === sectionId
      );
    });

    if (!sectionCards.length) {
      return;
    }

    if (
      preferredProductCard &&
      sectionCards.indexOf(preferredProductCard) > -1
    ) {
      sectionCards.forEach(function (productCard) {
        setBundleSectionCardSelected(
          productCard,
          productCard === preferredProductCard
        );
      });

      return;
    }

    var selectedCards = sectionCards.filter(isBundleSectionCardSelected);
    var keepCard = selectedCards.length ? selectedCards[0] : sectionCards[0];

    sectionCards.forEach(function (productCard) {
      setBundleSectionCardSelected(productCard, productCard === keepCard);
    });
  }

  function enforceBundleSectionSelections(preferredProductCard, cards) {
    var config = getBundleSectionsConfig();

    if (!config.sections.length || isSyncingBundleSectionSelections) {
      return;
    }

    var productCards = getAllGfbProductCards();
    if (!productCards.length) {
      return;
    }

    annotateBundleSectionCards(productCards);

    isSyncingBundleSectionSelections = true;

    try {
      var preferredSectionId = '';

      if (preferredProductCard && preferredProductCard.getAttribute) {
        preferredSectionId = String(
          preferredProductCard.getAttribute('data-c8-bundle-section-id') || ''
        ).trim();
      }

      if (preferredSectionId) {
        enforceSingleSelectionForSection(
          preferredSectionId,
          preferredProductCard,
          productCards
        );
      }

      config.sections.forEach(function (sectionConfig) {
        if (!sectionConfig || !sectionConfig.id) {
          return;
        }

        if (sectionConfig.id === preferredSectionId) {
          return;
        }

        enforceSingleSelectionForSection(sectionConfig.id, null, productCards);
      });
    } finally {
      updateBundleSectionSelectionState(productCards);
      isSyncingBundleSectionSelections = false;
    }
  }

  function scheduleBundleSectionSelectionSync(preferredProductCard, delay) {
    if (preferredProductCard) {
      queuedBundleSectionPreferredCard = preferredProductCard;
    }

    if (bundleSectionSyncTimer !== null) {
      window.clearTimeout(bundleSectionSyncTimer);
    }

    bundleSectionSyncTimer = window.setTimeout(
      function () {
        bundleSectionSyncTimer = null;
        enforceBundleSectionSelections(queuedBundleSectionPreferredCard);
        queuedBundleSectionPreferredCard = null;
      },
      Number.isFinite(delay) ? delay : 0
    );
  }

  function getTogetherOptionName(selectElement) {
    if (!selectElement) {
      return '';
    }

    return 'SHADE';
  }

  function applyTogetherOptionNameLabels(scopeNode) {
    var scopeElement =
      scopeNode && scopeNode.nodeType === 1 ? scopeNode : document;
    var selectElements = scopeElement.querySelectorAll(
      '.main-product .product-info__bundle-app .gfbProductBundleUpsellMasterDropdownSelector, .gfbProductBundleUpsellMasterDropdownSelector'
    );

    Array.prototype.forEach.call(selectElements, function (selectElement) {
      if (!selectElement || typeof selectElement.closest !== 'function') {
        return;
      }

      var productCard = selectElement.closest(
        '.gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together, .gfbFrequentBoughtWidgetProductContainer'
      );
      var selectedOptionWrapper = productCard
        ? productCard.querySelector('.gfbSelectedOptionWrapper')
        : null;

      if (!selectedOptionWrapper) {
        var dropdown = selectElement.closest('.gfbDropdownWithCustomIcon');
        selectedOptionWrapper = dropdown
          ? dropdown.querySelector('.gfbSelectedOptionWrapper')
          : null;
      }

      if (!selectedOptionWrapper) {
        return;
      }

      var selectedOptionLabel =
        selectedOptionWrapper.querySelector('.gfbSelectedOption');

      if (!selectedOptionLabel) {
        selectedOptionLabel = document.createElement('div');
        selectedOptionLabel.className = 'gfbSelectedOption';
        selectedOptionWrapper.textContent = '';
        selectedOptionWrapper.appendChild(selectedOptionLabel);
      }

      var optionName = getTogetherOptionName(selectElement);

      if (!optionName) {
        return;
      }

      selectedOptionLabel.textContent = optionName;
    });
  }
  function getSwatchColorValue(swatchButton) {
    if (!swatchButton || !swatchButton.style) {
      return '';
    }

    var color = String(
      swatchButton.style.getPropertyValue('--custom-swatch-color') || ''
    ).trim();
    var normalizedColor = color.toLowerCase();

    if (
      !color ||
      normalizedColor === 'transparent' ||
      normalizedColor === 'none' ||
      normalizedColor === 'initial' ||
      normalizedColor === 'unset' ||
      normalizedColor === 'inherit' ||
      normalizedColor === 'undefined' ||
      normalizedColor === 'null' ||
      normalizedColor === 'nan'
    ) {
      return '';
    }

    return color;
  }

  function upsertGfbSwatchLabel(swatchButton) {
    if (!swatchButton) {
      return;
    }

    var color = getSwatchColorValue(swatchButton);
    var label = String(
      swatchButton.getAttribute('data-color-name') || ''
    ).trim();
    var initialNode = swatchButton.querySelector('.c8-gfb-swatch-initial');

    if (color) {
      swatchButton.classList.remove('c8-gfb-swatch-text');
      if (initialNode) {
        initialNode.remove();
      }
      return;
    }

    swatchButton.classList.add('c8-gfb-swatch-text');

    if (!initialNode) {
      initialNode = document.createElement('span');
      initialNode.className = 'c8-gfb-swatch-initial';
      swatchButton.appendChild(initialNode);
    }

    initialNode.textContent = (label || '?').charAt(0).toUpperCase();
  }

  function updateGfbSwatchOverflow(swatchRow) {
    if (!swatchRow) {
      return;
    }

    var swatches = Array.prototype.slice.call(
      swatchRow.querySelectorAll('.gfbFrequentBoughtSwatchColorUI')
    );

    if (!swatches.length) {
      return;
    }

    var maxVisible = 5;
    var isExpanded =
      String(swatchRow.getAttribute('data-c8-gfb-swatches-expanded') || '') ===
      'true';
    var hiddenCount = 0;

    swatches.forEach(function (swatchButton, index) {
      var isHidden = !isExpanded && index >= maxVisible;
      swatchButton.classList.toggle('c8-gfb-swatch-overflow-hidden', isHidden);

      if (isHidden) {
        hiddenCount += 1;
      }
    });

    var moreButton = swatchRow.querySelector('.c8-gfb-swatch-more');

    if (!hiddenCount) {
      if (moreButton) {
        moreButton.remove();
      }
      return;
    }

    if (!moreButton) {
      moreButton = document.createElement('button');
      moreButton.type = 'button';
      moreButton.className = 'c8-gfb-swatch-more';
      moreButton.addEventListener('click', function (event) {
        event.preventDefault();
        swatchRow.setAttribute('data-c8-gfb-swatches-expanded', 'true');
        updateGfbSwatchOverflow(swatchRow);
      });
      swatchRow.appendChild(moreButton);
    }

    moreButton.textContent = '+' + hiddenCount;

    if (isExpanded) {
      moreButton.remove();
    }
  }

  function ensureGfbContentStack(productCard) {
    if (!productCard) {
      return;
    }

    var titleElement = productCard.querySelector(
      '.gfbFrequentBoughtWidgetProductTitle'
    );
    var metaContainer = productCard.querySelector(
      '.gfbFrequentBoughtWidgetProductContentNameVariantContainer'
    );

    if (!titleElement && !metaContainer) {
      return;
    }

    var contentStack = productCard.querySelector('.c8-gfb-content-stack');
    if (!contentStack) {
      contentStack = document.createElement('div');
      contentStack.className = 'c8-gfb-content-stack';
    }

    if (contentStack.parentNode !== productCard) {
      var priceContainer = productCard.querySelector(
        '.gfbFrequentBoughtWidgetProductPriceContainer'
      );

      if (priceContainer && priceContainer.parentNode === productCard) {
        productCard.insertBefore(contentStack, priceContainer);
      } else {
        productCard.appendChild(contentStack);
      }
    }

    if (titleElement && titleElement.parentNode !== contentStack) {
      contentStack.appendChild(titleElement);
    }

    if (metaContainer && metaContainer.parentNode !== contentStack) {
      contentStack.appendChild(metaContainer);
    }
  }

  function ensureGfbRatingPlacement(productCard) {
    if (!productCard) {
      return;
    }

    var contentContainer = productCard.querySelector(
      '.gfbFrequentBoughtWidgetProductContentNameVariantContainer'
    );

    if (!contentContainer) {
      return;
    }

    var variantContainer = contentContainer.querySelector(
      '.gfbFrequentBoughtVariantUIParentContainer'
    );

    if (!variantContainer) {
      variantContainer = document.createElement('div');
      variantContainer.className = 'gfbFrequentBoughtVariantUIParentContainer';
      contentContainer.appendChild(variantContainer);
    }

    var ratingRow = variantContainer.querySelector('.c8-gfb-rating-row');
    var ratingBadge =
      ratingRow && ratingRow.querySelector('.rating-badge')
        ? ratingRow.querySelector('.rating-badge')
        : productCard.querySelector('.rating-badge');

    if (!ratingBadge) {
      ratingBadge = getBundleItemRatingBadge(productCard);
    }

    if (!ratingBadge) {
      return;
    }

    if (!ratingRow) {
      ratingRow = document.createElement('div');
      ratingRow.className = 'c8-gfb-rating-row';
    }

    if (ratingBadge.parentNode !== ratingRow) {
      ratingRow.textContent = '';
      ratingRow.appendChild(ratingBadge);
    }

    var swatchContainer = variantContainer.querySelector(
      '.gfbFrequentBoughtSwatchContainer'
    );

    if (swatchContainer) {
      var swatchHeading = swatchContainer.querySelector(
        '.gfbFrequentBoughtSwatchHeading'
      );

      if (swatchHeading) {
        if (
          ratingRow.parentNode !== swatchContainer ||
          ratingRow.previousElementSibling !== swatchHeading
        ) {
          swatchHeading.insertAdjacentElement('afterend', ratingRow);
        }
      } else if (
        ratingRow.parentNode !== variantContainer ||
        ratingRow.nextElementSibling !== swatchContainer
      ) {
        variantContainer.insertBefore(ratingRow, swatchContainer);
      }

      return;
    }

    if (ratingRow.parentNode !== variantContainer) {
      variantContainer.appendChild(ratingRow);
    }
  }

  function enhanceGfbWidgetProducts(productCards) {
    var cards =
      productCards && productCards.length
        ? productCards
        : getAllGfbProductCards();

    Array.prototype.forEach.call(cards, function (productCard) {
      if (!document.documentElement.contains(productCard)) {
        return;
      }

      ensureGfbContentStack(productCard);
      ensureGfbRatingPlacement(productCard);

      var swatchRows = productCard.querySelectorAll(
        '.gfbFrequentBoughtSwatchParentContainer'
      );

      Array.prototype.forEach.call(swatchRows, function (swatchRow) {
        var swatches = swatchRow.querySelectorAll(
          '.gfbFrequentBoughtSwatchColorUI'
        );

        Array.prototype.forEach.call(swatches, function (swatchButton) {
          upsertGfbSwatchLabel(swatchButton);
        });

        updateGfbSwatchOverflow(swatchRow);
      });
    });
  }

  function addUniqueNode(nodes, node) {
    if (!node || nodes.indexOf(node) > -1) {
      return;
    }

    nodes.push(node);
  }

  function isElementNode(node) {
    return Boolean(node && node.nodeType === 1);
  }

  function collectGfbProductsFromNode(node, collection, includeNested) {
    var selector =
      '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together';

    if (!isElementNode(node)) {
      return;
    }

    if (typeof node.matches === 'function' && node.matches(selector)) {
      addUniqueNode(collection, node);
    }

    if (typeof node.closest === 'function') {
      var closestCard = node.closest(selector);
      if (closestCard) {
        addUniqueNode(collection, closestCard);
      }
    }

    if (includeNested !== true || typeof node.querySelectorAll !== 'function') {
      return;
    }

    var nestedCards = node.querySelectorAll(selector);
    Array.prototype.forEach.call(nestedCards, function (card) {
      addUniqueNode(collection, card);
    });
  }

  function isOwnGfbDecorationNode(node) {
    if (!isElementNode(node)) {
      return false;
    }

    if (
      node.classList &&
      (node.classList.contains('c8-gfb-rating-row') ||
        node.classList.contains('c8-gfb-swatch-more') ||
        node.classList.contains('c8-gfb-swatch-initial'))
    ) {
      return true;
    }

    if (typeof node.closest === 'function') {
      return Boolean(
        node.closest(
          '.c8-gfb-rating-row, .c8-gfb-swatch-more, .c8-gfb-swatch-initial'
        )
      );
    }

    return false;
  }

  function applyEnhancementsNow(productCards) {
    if (isApplyingEnhancements) {
      return;
    }

    applyTogetherOptionNameLabels();

    var cards =
      productCards && productCards.length
        ? productCards
        : getAllGfbProductCards();
    if (!cards.length) {
      return;
    }

    isApplyingEnhancements = true;

    try {
      enhanceGfbWidgetProducts(cards);
      enforceBundleSectionSelections(null);
    } finally {
      isApplyingEnhancements = false;
    }
  }

  function flushEnhancementQueue() {
    enhancementTimer = null;
    if (isApplyingEnhancements) {
      return;
    }

    var cards = queuedEnhancementProducts.slice();
    queuedEnhancementProducts = [];
    applyEnhancementsNow(cards);
  }

  function queueEnhancement(productCards, delay) {
    Array.prototype.forEach.call(productCards || [], function (productCard) {
      addUniqueNode(queuedEnhancementProducts, productCard);
    });

    if (enhancementTimer !== null) {
      window.clearTimeout(enhancementTimer);
    }

    enhancementTimer = window.setTimeout(
      flushEnhancementQueue,
      Number.isFinite(delay) ? delay : 0
    );
  }

  function scheduleEnhancementRun(delay) {
    queueEnhancement(getAllGfbProductCards(), delay);
  }

  function getGfbProductIdentity(productCard) {
    if (!productCard) {
      return null;
    }

    var handle = getProductHandleFromCard(productCard);
    var titleElement = productCard.querySelector(
      '.gfbFrequentBoughtWidgetProductTitle'
    );
    var titleKey = normalizeText(titleElement ? titleElement.textContent : '');

    if (!handle && !titleKey) {
      return null;
    }

    return {
      handle: handle,
      titleKey: titleKey
    };
  }

  function getGfbProductsByIdentity(identity) {
    if (!identity) {
      return [];
    }

    var cards = getAllGfbProductCards();
    return cards.filter(function (productCard) {
      if (
        identity.handle &&
        getProductHandleFromCard(productCard) === identity.handle
      ) {
        return true;
      }

      if (!identity.titleKey) {
        return false;
      }

      var titleElement = productCard.querySelector(
        '.gfbFrequentBoughtWidgetProductTitle'
      );
      var titleKey = normalizeText(
        titleElement ? titleElement.textContent : ''
      );
      return titleKey === identity.titleKey;
    });
  }

  function queueEnhancementByIdentity(identity, delays) {
    if (!identity) {
      return;
    }

    var updateDelays = Array.isArray(delays) ? delays : [0];
    updateDelays.forEach(function (delay) {
      window.setTimeout(
        function () {
          var identityCards = getGfbProductsByIdentity(identity);
          applyEnhancementsNow(identityCards);
          queueEnhancement(identityCards, 60);
        },
        Number.isFinite(delay) ? delay : 0
      );
    });
  }

  function bindGfbEnhancementObserver() {
    var bundleRoot = document.querySelector(
      '.main-product .product-info__bundle-app'
    );

    if (!bundleRoot) {
      return;
    }

    if (observedBundleRoot === bundleRoot && bundleObserver) {
      return;
    }

    syncTemplateTogetherClassAliases(bundleRoot);

    if (bundleObserver) {
      bundleObserver.disconnect();
    }

    observedBundleRoot = bundleRoot;
    bundleObserver = new MutationObserver(function (mutations) {
      if (isApplyingEnhancements) {
        return;
      }

      var touchedProducts = [];
      var shouldSyncAll = false;

      Array.prototype.forEach.call(mutations || [], function (mutation) {
        var targetElement = getElementNode(mutation.target);

        if (targetElement && isOwnGfbDecorationNode(targetElement)) {
          return;
        }

        if (targetElement) {
          collectGfbProductsFromNode(targetElement, touchedProducts, false);
        }

        Array.prototype.forEach.call(
          mutation.addedNodes || [],
          function (addedNode) {
            if (
              !isElementNode(addedNode) ||
              isOwnGfbDecorationNode(addedNode)
            ) {
              return;
            }

            syncTemplateTogetherClassAliases(addedNode);

            if (
              (typeof addedNode.matches === 'function' &&
                addedNode.matches(
                  '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
                )) ||
              (typeof addedNode.querySelector === 'function' &&
                addedNode.querySelector(
                  '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
                ))
            ) {
              shouldSyncAll = true;
            }

            collectGfbProductsFromNode(addedNode, touchedProducts, true);
          }
        );

        Array.prototype.forEach.call(
          mutation.removedNodes || [],
          function (removedNode) {
            if (
              !isElementNode(removedNode) ||
              isOwnGfbDecorationNode(removedNode)
            ) {
              return;
            }

            if (
              (typeof removedNode.matches === 'function' &&
                removedNode.matches(
                  '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
                )) ||
              (typeof removedNode.querySelector === 'function' &&
                removedNode.querySelector(
                  '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
                ))
            ) {
              shouldSyncAll = true;
            }
          }
        );
      });

      if (shouldSyncAll) {
        var allCards = getAllGfbProductCards();
        applyEnhancementsNow(allCards);
        queueEnhancement(allCards, 90);
        return;
      }

      if (touchedProducts.length) {
        applyEnhancementsNow(touchedProducts);
        queueEnhancement(touchedProducts, 90);
        return;
      }

      applyTogetherOptionNameLabels(bundleRoot);
    });

    bundleObserver.observe(bundleRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });

    bundleRoot.addEventListener(
      'click',
      function (event) {
        if (isProgrammaticBundleSectionToggle) {
          return;
        }

        var targetElement = getElementNode(event.target);
        if (!targetElement || typeof targetElement.closest !== 'function') {
          return;
        }

        var productCard = targetElement.closest(
          '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
        );

        if (!productCard) {
          return;
        }

        var sectionId = String(
          productCard.getAttribute('data-c8-bundle-section-id') || ''
        ).trim();

        if (!sectionId || isBundleSectionCardSelected(productCard)) {
          return;
        }

        setBundleSectionCardSelected(productCard, true);
        scheduleBundleSectionSelectionSync(productCard, 20);
      },
      true
    );

    bundleRoot.addEventListener(
      'click',
      function (event) {
        var targetElement = getElementNode(event.target);
        if (!targetElement || typeof targetElement.closest !== 'function') {
          return;
        }

        var swatchButton = targetElement.closest(
          '.gfbFrequentBoughtSwatchColorUI'
        );
        if (!swatchButton) {
          return;
        }

        var productCard = swatchButton.closest(
          '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
        );
        if (!productCard) {
          return;
        }

        var identity = getGfbProductIdentity(productCard);
        var identityCards = getGfbProductsByIdentity(identity);

        applyEnhancementsNow(identityCards);
        scheduleBundleSectionSelectionSync(productCard, 20);
        queueEnhancementByIdentity(identity, [80, 180]);

        window.setTimeout(function () {
          applyEnhancementsNow(getAllGfbProductCards());
        }, 140);
      },
      true
    );

    bundleRoot.addEventListener(
      'change',
      function (event) {
        var targetElement = getElementNode(event.target);
        if (!targetElement || typeof targetElement.closest !== 'function') {
          return;
        }

        var productCardCheckbox = targetElement.closest(
          '.gfbFrequentBoughtWidgetProductContainer input[type="checkbox"], .gfbBundleProductContainer_Template1 input[type="checkbox"], .gfbBundleProductContainer_Together input[type="checkbox"]'
        );

        if (productCardCheckbox) {
          if (isSyncingBundleSectionSelections) {
            return;
          }

          var selectedProductCard = productCardCheckbox.closest(
            '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
          );

          scheduleBundleSectionSelectionSync(selectedProductCard, 20);
          return;
        }

        var selectElement = targetElement.closest(
          '.gfbProductBundleUpsellMasterDropdownSelector'
        );

        if (!selectElement) {
          return;
        }

        window.setTimeout(function () {
          applyTogetherOptionNameLabels(
            selectElement.closest('.gfbDropdownWithCustomIcon') || bundleRoot
          );
        }, 40);

        var selectedFromDropdownCard = selectElement.closest(
          '.gfbFrequentBoughtWidgetProductContainer, .gfbBundleProductContainer_Template1, .gfbBundleProductContainer_Together'
        );

        if (selectedFromDropdownCard) {
          scheduleBundleSectionSelectionSync(selectedFromDropdownCard, 40);
        }
      },
      true
    );
  }

  function dispatchGfbAddToCartClick(gfbButton) {
    if (!gfbButton) {
      return;
    }

    gfbButton.dispatchEvent(
      new MouseEvent('mousedown', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    gfbButton.dispatchEvent(
      new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    gfbButton.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );
  }

  function handleMainProductAtcClickToGfb(event) {
    if (isProxyingClickToGfb) {
      return;
    }

    var targetElement = getElementNode(event.target);
    if (!targetElement || typeof targetElement.closest !== 'function') {
      return;
    }

    var defaultAtcButton = targetElement.closest(
      '.main-product .product-info__actions [data-fly-bundles-atc-btn="true"], .main-product .product-info__actions .shopify-product-form > button[type="submit"]'
    );

    if (!defaultAtcButton || defaultAtcButton.disabled) {
      return;
    }

    var gfbButton = getGfbBundleAtcButton();
    if (!gfbButton) {
      return;
    }

    event.preventDefault();

    isProxyingClickToGfb = true;

    try {
      dispatchGfbAddToCartClick(gfbButton);
    } finally {
      window.setTimeout(function () {
        isProxyingClickToGfb = false;
      }, 500);
    }
  }

  function bootstrap() {
    syncTemplateTogetherClassAliases();
    applyEnhancementsNow(getAllGfbProductCards());
    bindGfbEnhancementObserver();
    scheduleEnhancementRun(120);
  }

  document.addEventListener('click', handleMainProductAtcClickToGfb, true);
  bootstrap();
})();
